import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout, clearError } from '../store/authSlice';
import { showToast } from '../store/uiSlice';
import authService from '../services/authService';

const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isAuthenticated, loading, error } = useSelector((state) => state.auth);

  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      dispatch(logout());
      dispatch(showToast({ message: 'Logged out successfully', type: 'success' }));
      navigate('/login');
    }
  };

  const clearAuthError = () => {
    dispatch(clearError());
  };

  const updateUserProfile = async (profileData) => {
    try {
      const response = await authService.updateProfile(profileData);
      dispatch(showToast({ message: 'Profile updated successfully', type: 'success' }));
      return response.user;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to update profile';
      dispatch(showToast({ message, type: 'error' }));
      throw error;
    }
  };

  const changeUserPassword = async (currentPassword, newPassword) => {
    try {
      await authService.changePassword(currentPassword, newPassword);
      dispatch(showToast({ message: 'Password changed successfully', type: 'success' }));
      return true;
    } catch (error) {
      const message = error.response?.data?.message || 'Failed to change password';
      dispatch(showToast({ message, type: 'error' }));
      throw error;
    }
  };

  return {
    user,
    isAuthenticated,
    loading,
    error,
    logout: handleLogout,
    clearError: clearAuthError,
    updateProfile: updateUserProfile,
    changePassword: changeUserPassword,
  };
};

export default useAuth;